import React from "react";
import { useSelector } from "react-redux";
import StoneRateGrid from "../../../components/Rates/StoneRateGrid";

const StoneRateMatrix = () => {
  const { selectedBranch } = useSelector((state) => state.rate.ui);
  const { user } = useSelector((state) => state.auth);

  const currentBranch = selectedBranch || user?.branchAccess?.primaryBranch;

  return (
    <div className="max-w-7xl mx-auto space-y-6">
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold mb-2">Stone Rate Management</h1>
        <p className="text-gray-600">Manage diamond and gemstone pricing</p>
      </div>

      <StoneRateGrid branchCode={currentBranch} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="font-semibold mb-4">Colored Stones</h3>
          <div className="space-y-3">
            {["Ruby", "Sapphire", "Emerald"].map((stone) => (
              <div
                key={stone}
                className="flex justify-between items-center p-3 border rounded"
              >
                <span>{stone}</span>
                <button className="text-blue-600 hover:text-blue-700">
                  Configure →
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="font-semibold mb-4">Import/Export</h3>
          <div className="space-y-3">
            <button className="w-full px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">
              Import from Excel
            </button>
            <button className="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
              Export Current Rates
            </button>
          </div>
          {currentBranch && (
            <p className="text-xs text-gray-500 mt-3">
              Branch: {currentBranch}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default StoneRateMatrix;
